import { View, html } from 'rune-ts';
import klass from './MyPageMenu.module.scss';
import { classes } from '../../../../../shared/util';
import { font } from '../../../../../shared/typography';

export interface MyPageMenuItemProps {
  title: string;
  href: string;
  active: boolean;
}

export interface MyPageMenuProps {
  menu: MyPageMenuItemProps[];
}

class MyPageMenuItem extends View<MyPageMenuItemProps> {
  override template() {
    return html`<a href="${this.data.href}" data-active="${this.data.active}" class="${font('16_medium')}">
      ${this.data.title}
    </a>`;
  }
}

export class MyPageMenu extends View<MyPageMenuProps> {
  myPageMenuItemsView: MyPageMenuItem[];

  constructor(props: MyPageMenuProps) {
    super(props);
    const { menu } = props;
    this.myPageMenuItemsView = menu.map((menu) => new MyPageMenuItem(menu));
  }

  override template() {
    return html`
      <div class="${klass.my_page_menu}">
        <a href="/${ET.lang}/@/mypage" class="${font('28_bold')}">${T('mypage::마이페이지')}</a>
        <div class="${classes(klass.my_page_menu_items)}">${this.myPageMenuItemsView}</div>
      </div>
    `;
  }
}
